export default __webpack_public_path__ + "static/ADOT-metrics-730e2044feae236761b87bde2b9d0802.png";